










































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import ffButton from '@/components/public/Button.vue'
import { Collapse, CollapseItem, Icon, Toast } from 'vant'
import { addGA, errorGA } from '../utils/index'
import { setCookie, getCookie } from '../utils'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
const appStore = namespace('app')

type Replace<T> = (text: string) => T

@Component({
  components: {
    ffButton,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon
  }
})
export default class Download extends Vue {
  private activeName: Array<string> = ['0']
  @appStore.State((state) => state.transify) private transify: object
  @appStore.State((state) => state.downloadOpen) private downloadOpen: boolean
  @appStore.State((state) => state.activationCode)
  private activationCode: string
  @appStore.State((state) => state.feedbackOpen) private feedbackOpen: boolean
  @appStore.State((state) => state.apkLink) private apkLink: string
  @appStore.State((state) => state.playtestStartTime)
  private playtestStartTime: number
  @appStore.State((state) => state.gameLogin) private gameLogin: boolean
  @appStore.Action('updateHasDownload') private updateHasDownload!: Function
  @appStore.Action('setUserInfo') private setUserInfo!: Function
  get FaqList(): Array<object> {
    const faqArr: Array<object> = []
    for (const key in this.transify) {
      if (key.indexOf('ADV_DOWNLOAD_FAQ_Q') > -1) {
        const num = key.charAt(key.length - 1)
        faqArr.push({
          title: this.transify[`ADV_DOWNLOAD_FAQ_Q${num}`],
          answer: this.transify[`ADV_DOWNLOAD_FAQ_A${num}`]
        })
      }
    }
    return faqArr
  }
  get DownloadTime(): string {
    const date = new Date(this.playtestStartTime * 1000)
    const [day, month, year] = [
      date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1,
      date.getFullYear()
    ]
    return this.transify['ADV_DOWNLOAD_HINT_1']
      ? this.transify['ADV_DOWNLOAD_HINT_1']
          .replace('{day}', day.toString() + '.')
          .replace('{month}', month.toString() + '.')
          .replace('{year}', year.toString())
      : ''
  }
  DownloadApk(): void {
    if (!this.downloadOpen) return
    window.location.href = this.apkLink // 跳转下载链接
  }
  handleFeedBack(): void {
    if (!this.gameLogin) {
      Toast(this.transify['ADV_DOWNLOAD_REPORTBUG_HINT'])
      return
    } else {
      this['$router'].push('/feedback').catch(() => {
        return
      })
    }
  }
  userInfo(): void {
    this['$http'].get(`/info`).then((res: any) => {
      this.setUserInfo(res.data)
    })
  }
  mounted(): void {
    this.userInfo()
  }
}
